/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useIntl } from "react-intl";

import { PurposedButtonProps } from "./types";
import { useTheme } from "../../../../config/emotion";
import EwaButton2 from "./EwaButton/EwaButton2";
import { labellessButtonCss } from "./styles";

const ResetButton = (props: PurposedButtonProps) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();

  return (
    <EwaButton2
      data-cy="reset-filtr-button"
      buttonColor={colors.secondaryColor}
      tooltip={formatMessage({ id: "common.reset" })}
      iconName="rotate_left"
      css={labellessButtonCss}
      {...props}
    />
  );
};

export default ResetButton;
